import { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMsal } from '@azure/msal-react';

// material-ui
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';

import { useTranslation } from 'react-i18next';

import { LOGOUT } from 'store/actions';

import AuthService from '../../../../services/auth.service';

// ==============================|| PROFILE MENU ||============================== //

const ProfileSection = () => {
    /**
     * anchorRef is used on different componets and specifying one type leads to other components throwing an error
     * */
    const anchorRef = useRef(null);

    const { t, i18n } = useTranslation();
    const { instance } = useMsal();

    const dispatch = useDispatch();

    const clientId = useSelector((state) => state.session.clientId);
    const username = useSelector((state) => state.session.username);

    const logOut = async () => {
        try {
            // Call backend logout
            await AuthService.logout();
        } catch (error) {
            const resMessage =
                (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            console.log(resMessage);
        }

        // Dispatch logout action to clear Redux store
        dispatch({ type: LOGOUT });

        // Logout from MSAL
        try {
            await instance.logoutPopup({
                postLogoutRedirectUri: '/',
                mainWindowRedirectUri: '/',
            });
        } catch (error) {
            console.error('MSAL logout error:', error);
            // Fallback to redirect if popup fails
            window.location.href = '/';
        }
    };

    return (
        <div className="col-lg-6 pr-30" style={{ textAlign: 'right' }}>
            <p className="company" style={{ color: 'black' }}>
                {clientId}
            </p>
            <p className="username" style={{ color: 'black' }}>
                {username}
            </p>
            <Link className="log-out" href="#" underline="always" onClick={(e) => { e.preventDefault(); logOut(); }}>
                {t('shared.signOut')}
            </Link>
        </div>
    );
};

export default ProfileSection;
